module.exports = __webpack_public_path__ + "img/bg-login.a9ba1896.png";